import {
  ACTUAL_STATE_IMAGES_SAVE,
  CHECKLIST_DATA_UPDATE,
  MAIN_CHECKLIST_ARRAY_GET,
  ACTUAL_STATE_IMAGES_GET,
  CHECKLIST_ITEM_DATA_GET,
  CHECKLIST_DATA_RESET,
  FUEL_ARRAY_GET,
  HOROMETRO_SET_DATA,
  HOROMETRO_RESET_DATA,
  SAVE_STATUS_DETAIL,
  ODOO_CHECKLIST_URL_SAVE,
  SET_ORDER_DATA,
  CHECKLIST_REFERENCE_TRANSFER,
  FUEL_ARRAY_RESET,
  SET_CHECKLIST_DATA,
  UPDATE_STATE_CHECKLIST,
  SET_BRANCH_DATA,
  SET_EMAILS_NOTIFICATIONS
} from "./mutation-types";
import { loaderDone, loaderStart } from "@/services/LoaderService";
import { errorMessage, showMessage } from "@/services/MessageService";
import { answersEmail } from "../../../models/damage/TemplateHTML";
import { imagesMap } from "@/models/damage/ActualStateImages";
import * as localforage from "localforage";
import { database } from "@/config/firebase";

import {
  firestore,
  firestoreDb,
  firestoreField,
  storageRef,
  functions
} from "@/config/firebase";
import moment from "moment";
import { getUrlFromStorage } from "../../../services/Images";

function getImageURL(checklistPath, image, imageId) {
  let imageType = image.substring(
    "data:image/".length,
    image.indexOf(";base64")
  );
  return `${checklistPath}/${imageId}.${imageType}`;
}

export default {
  // :: createChecklistRefs
  // :: Create documents of the checklist in firetore
  async createChecklistRefs(_, data) {
    const firebaseProductRef = firestore("damages")
      .doc(data.id)
      .collection("order")
      .doc(data.productID);
    const firebaseEventRef = firestore("damages")
      .doc(data.id)
      .collection("order")
      .doc(data.productID)
      .collection(data.eventType)
      .doc();
    const firebaseChecklistRef = firebaseEventRef
      .collection(data.checklistType)
      .doc();
    return {
      eventRef: firebaseEventRef,
      productRef: firebaseProductRef,
      checklistRef: firebaseChecklistRef
    };
  },
  async createChecklistTransferRefs({ commit }, data) {
    try {
      const itemRef = await firestore("transfers")
        .doc(data.id)
        .get();
      var itemPath = itemRef.ref.path;
      const checklistRef = await firestore(itemPath + "/checklist").doc();
      commit(CHECKLIST_REFERENCE_TRANSFER, checklistRef);
      return checklistRef;
    } catch (error) {
      errorMessage(
        "No se pudo guardar el checklist, ocurrio un error inesperado."
      );
    }
  },
  /**
   * Saves a single check item information into the firestore database
   * @param {*} data receives check item information as an object that contains
   * - name :: name of the check item
   * - path :: path of the check item to query the images
   * - checklist :: checklist data like description, title, name, checked
   * - eventRef :: event reference of database to set the timestamp of creation or edition
   * - productef :: product reference of database to set the timestamp of lastUpdate
   * - checklistRef :: checklist reference of database to save the information an images inside the database
   * - checklistType :: the type of checklist event (output or input)
   */
  async saveChecklistInicidence({ commit }, checklist) {
    loaderStart();
    try {
      commit(CHECKLIST_DATA_UPDATE, checklist);
      showMessage({
        message: "La incidencia se ha guardado correctamente",
        color: "success"
      });
      loaderDone();
    } catch (error) {
      errorMessage("Ocurrió un error inesperado al guardar");
      loaderDone();
    }
  },
  resetFuelData({ commit }) {
    commit(FUEL_ARRAY_RESET);
  },
  // :: saveChecklistSuccess
  // :: Save all checks that were approved
  async saveChecklist({ state, dispatch, rootState }, data) {
    try {
      const { eventRef, productRef, checklistRef } = await dispatch(
        "createChecklistRefs",
        data
      );
      dispatch("saveChecklistImages", checklistRef.path);
      eventRef.set(
        {
          date: firestoreField.serverTimestamp(),
          event: data.checklistType,
          completed: true
        },
        { merge: true }
      );
      checklistRef.set(
        {
          savedChecklists: state.checklistArray,
          completed: true,
          savedFuel: state.checklistFuelData,
          checklistPhysical: state.checklistPhysicalImages,
          emailNotifications: state.emailNotifications,
          savedHorometro: state.horometro,
          machineImages: state.machineImages,
          signTransportits: false,
          signReceptor: false,
          invalidChecklistStatus: data.invalidChecklistStatus,
          metadata: {
            path: data.path,
            orderId: data.orderId
          }
        },
        { merge: true }
      );
      if (state.videos.src && !rootState.user.userOnline)
        dispatch("saveChecklistVideos", checklistRef);
      dispatch(
        "orders/updateOrderStatus",
        {
          productRef,
          status: data.statusID,
          correctStatus: data.correctStatus
        },
        { root: true }
      );
      return {
        eventPath: eventRef.path,
        productPath: productRef.path,
        checklistPath: checklistRef.path
      };
    } catch (error) {
      errorMessage(
        "Ocurrió un error inesperado al guardar :: saveChecklistSuccess ::"
      );
      return { eventPath: null, productPath: null, checklistPath: null };
    }
  },
  async saveChecklistVideos({ state }, checklistRef) {
    try {
      const videoName = state.videos.file.name;
      const videoFile = state.videos.file;
      const videoURL = `${checklistRef.path}/videos/${videoName}`;
      await storageRef.child(videoURL).put(videoFile);
      let videoDownloadURL = await storageRef.child(videoURL).getDownloadURL();
      checklistRef.set(
        {
          videos: {
            src: videoDownloadURL,
            titleSection: "Video de checklist"
          }
        },
        { merge: true }
      );
    } catch (error) {
      errorMessage("Ocurrió un error al subir el video");
    }
  },
  async saveChecklistImages({ state, dispatch, commit }, checklistPath) {
    // :: Save incidences images
    for (let index = 0; index < state.checklistArray.length; index++) {
      const checklist = state.checklistArray[index];
      if (checklist.incidence) {
        for (let i = 0; i < checklist.images.length; i++) {
          const image = checklist.images[i];
          if (image.src) {
            const url = getImageURL(
              checklistPath,
              image.src,
              `savedChecklists/i-${index}-${i}`
            );
            dispatch("saveImageInFirebaseDoc", {
              image: image.src,
              url
            });
            commit(UPDATE_STATE_CHECKLIST, {
              type: "incidence",
              indexArray: index,
              indexImage: i,
              url
            });
          }
        }
      }
    }
    let url = "";
    // :: save horometro image
    if (!state.horometro.notApply) {
      url = getImageURL(checklistPath, state.horometro.image, "horometro");
      dispatch("saveImageInFirebaseDoc", {
        image: state.horometro.image,
        url
      });
      commit(UPDATE_STATE_CHECKLIST, {
        type: "horometro",
        url
      });
    }
    // :: save physical checklist image
    url = getImageURL(
      checklistPath,
      state.checklistPhysicalImages.src,
      "physical"
    );
    dispatch("saveImageInFirebaseDoc", {
      image: state.checklistPhysicalImages.src,
      url
    });
    commit(UPDATE_STATE_CHECKLIST, {
      type: "physical",
      url
    });
    // :: save machine image
    for (let iMachine = 0; iMachine < state.machineImages.length; iMachine++) {
      const image = state.machineImages[iMachine];
      if (image.src) {
        url = getImageURL(checklistPath, image.src, `machine-${iMachine}`);
        dispatch("saveImageInFirebaseDoc", {
          image: image.src,
          url
        });
        commit(UPDATE_STATE_CHECKLIST, {
          type: "machine",
          url,
          michineindex: iMachine
        });
      }
    }
  },
  saveImageInFirebaseDoc(_, { image, url }) {
    firestoreDb.collection("checklistImages").add({
      image,
      url
    });
  },
  /**
   * Save images in the Actual State of the checklist order
   * @param {*} data receives an object that contains:
   * - checklist reference to the firestore database to save images in firebase storage
   * - path identifier to the checklist, to get the reference of each image in local forage
   */
  async saveActualStateImages({ commit, rootState }, data) {
    let actualStateImagesKeys = Object.values(imagesMap);
    const imagesObject = {};
    for (let x = 0; x < actualStateImagesKeys.length; x++) {
      const currentImageKey = data.path + "-" + actualStateImagesKeys[x];
      let currentImageObject = await localforage.getItem(currentImageKey);
      if (currentImageObject) {
        let imageType = currentImageObject.thumbnail.substring(
          "data:image/".length,
          currentImageObject.thumbnail.indexOf(";base64")
        );
        const imageURL = `${
          data.checklistRef.path
        }/actualState/thumb-${currentImageKey}.${imageType}`;
        await storageRef
          .child(imageURL)
          .putString(currentImageObject.thumbnail, "data_url");
        let thumbImageStateRef = await storageRef.child(imageURL);
        imagesObject[currentImageKey] = {
          thumb: await thumbImageStateRef.getDownloadURL()
        };
        /**
         * Clear images from check items and actual state
         * it's placed in this step because this functions
         * executes once at the end of the checklist completion
         */
        rootState.checklistImages.itemsActualState[currentImageKey] = null;
        rootState.checklistImages.itemsCheck = {};
      }
      currentImageObject = null;
    }
    commit(ACTUAL_STATE_IMAGES_SAVE, { actualStateImages: imagesObject });
  },
  async getChecklistRefData(
    _,
    { checklistID, checklistProductID, checklistEvent, checklistType }
  ) {
    // id, productID, checklistType, eventType
    const checklistEventRef = await firestore("damages")
      .doc(checklistID)
      .collection("order")
      .doc(checklistProductID)
      .collection(checklistEvent)
      .where("event", "==", checklistType)
      .get();

    const checklistEventPath = checklistEventRef.docs[0].ref.path;
    const checklistRef = await firestore(
      `${checklistEventPath}/${checklistType}`
    ).where("completed", "==", true);
    return checklistRef;
  },

  async getStockPickingChecklistData({ commit }, { albraranId, checklistId }) {
    const albaranRef = firestore("stock-picking").doc(albraranId);
    const checklistEventRef = albaranRef
      .collection("checklist")
      .doc(checklistId);
    const checklistComponentsRef = checklistEventRef.collection("components");
    const credentialsRef = checklistEventRef.collection("credentials");

    const checklistEventSnapshot = await checklistEventRef.get();
    const albaranSnapshot = await albaranRef.get();
    const checklistComponents = await checklistComponentsRef.get();
    const credentialsQuerySnapshot = await credentialsRef.get();

    const savedChecklists = [];
    checklistComponents.forEach(component => {
      const images = [];
      if (component.data().incidence) {
        if (component.data().pictureOne) {
          images.push({
            src: component.data().pictureOne,
            id: 1,
            titleSection: "Tomar foto 1"
          });
        }
        if (component.data().pictureTwo) {
          images.push({
            src: component.data().pictureTwo,
            id: 1,
            titleSection: "Tomar foto 2"
          });
        }
        if (component.data().pictureThree) {
          images.push({
            src: component.data().pictureThree,
            id: 1,
            titleSection: "Tomar foto 3"
          });
        }
        if (component.data().pictureFour) {
          images.push({
            src: component.data().pictureFour,
            id: 1,
            titleSection: "Tomar foto 4"
          });
        }
      }

      savedChecklists.push({
        title: component.data().name,
        checklistName: component.id,
        checked: component.data().checked,
        incidence: component.data().incidence,
        applies: component.data().applies,
        description: component.data().description,
        images: images
      });
    });
    const machineImages = [
      {
        titleSection: "Frente",
        src: checklistEventSnapshot.data().pictureFront,
        id: 1
      },
      {
        titleSection: "Posterior",
        src: checklistEventSnapshot.data().pictureLater,
        id: 2
      },
      {
        titleSection: "Lateral 1",
        src: checklistEventSnapshot.data().pictureSide1,
        id: 3
      },
      {
        titleSection: "Lateral 2",
        src: checklistEventSnapshot.data().pictureSide2,
        id: 4
      },
      {
        titleSection: "Llanta FD",
        src: checklistEventSnapshot.data().pictureTireFD,
        id: 5
      },
      {
        titleSection: "Llanta FI",
        src: checklistEventSnapshot.data().pictureTireFI,
        id: 6
      },
      {
        titleSection: "Lanta PD",
        src: checklistEventSnapshot.data().pictureTirePD,
        id: 7
      },
      {
        titleSection: "Llanta PI",
        src: checklistEventSnapshot.data().pictureTirePI,
        id: 8
      }
    ];

    const savedHorometro = {
      notApply: !checklistEventSnapshot.data().hourmeter,
      image: checklistEventSnapshot.data().hourmeterPicture,
      value: checklistEventSnapshot.data().hourmeter
    };

    const signedChecklistDeliverer = {
      signImage: "",
      identificationFront: "",
      identificationBack: ""
    };
    const signedChecklistReceiver = {
      signImage: "",
      identificationFront: "",
      identificationBack: ""
    };
    credentialsQuerySnapshot.forEach(credential => {
      if (credential.data().type === "delivery") {
        signedChecklistDeliverer.signImage = credential.data().signature;
        signedChecklistDeliverer.identificationFront = credential.data().pictureIdFront;
        signedChecklistDeliverer.identificationBack = credential.data().pictureIdBack;
      } else {
        signedChecklistReceiver.signImage = credential.data().signature;
        signedChecklistReceiver.identificationFront = credential.data().pictureIdFront;
        signedChecklistReceiver.identificationBack = credential.data().pictureIdBack;
      }
    });
    commit(SET_CHECKLIST_DATA, {
      savedChecklists,
      machineImages,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      checklistPhysical: { titleSection: "Frente", src: null },
      emailNotifications: checklistEventSnapshot.data().emailList,
      albaran: albaranSnapshot.data().name,
      albaranCheckListReason: checklistEventSnapshot.data().checklistReason,
      albaranType: checklistEventSnapshot.data().type
    });
  },
  async updateStateChecklistConsult({ commit, dispatch }, data) {
    if (data.actualStateImages)
      return dispatch("consultOldChecklistData", data);
    const {
      savedChecklists,
      savedFuel,
      machineImages,
      checklistPhysical,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      emailNotifications,
      videos
    } = data;
    commit(SET_CHECKLIST_DATA, {
      savedChecklists,
      savedFuel,
      machineImages,
      checklistPhysical,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      emailNotifications,
      videos
    });
    for (let index = 0; index < savedChecklists.length; index++) {
      const checklist = savedChecklists[index];
      if (checklist.incidence) {
        for (let i = 0; i < checklist.images.length; i++) {
          const image = checklist.images[i];
          if (image.src) {
            savedChecklists[index].images[i].src = await getUrlFromStorage(
              image.src
            );
          }
        }
      }
    }
    if (!savedHorometro.notApply)
      savedHorometro.image = await getUrlFromStorage(savedHorometro.image);
    checklistPhysical.src = await getUrlFromStorage(checklistPhysical.src);
    for (let iMachine = 0; iMachine < machineImages.length; iMachine++) {
      const image = machineImages[iMachine];
      if (image.src) {
        machineImages[iMachine].src = await getUrlFromStorage(image.src);
      }
    }
    signedChecklistDeliverer.signImage = await getUrlFromStorage(
      signedChecklistDeliverer.signImage
    );
    if (signedChecklistDeliverer.identificationFront)
      signedChecklistDeliverer.identificationFront = await getUrlFromStorage(
        signedChecklistDeliverer.identificationFront
      );
    if (signedChecklistDeliverer.identificationBack)
      signedChecklistDeliverer.identificationBack = await getUrlFromStorage(
        signedChecklistDeliverer.identificationBack
      );
    signedChecklistReceiver.signImage = await getUrlFromStorage(
      signedChecklistReceiver.signImage
    );
    if (signedChecklistReceiver.identificationFront)
      signedChecklistReceiver.identificationFront = await getUrlFromStorage(
        signedChecklistReceiver.identificationFront
      );
    if (signedChecklistReceiver.identificationBack)
      signedChecklistReceiver.identificationBack = await getUrlFromStorage(
        signedChecklistReceiver.identificationBack
      );
    if (signedChecklistReceiver.orderFront)
      signedChecklistReceiver.orderFront = await getUrlFromStorage(
        signedChecklistReceiver.orderFront
      );
    if (signedChecklistReceiver.orderBack)
      signedChecklistReceiver.orderBack = await getUrlFromStorage(
        signedChecklistReceiver.orderBack
      );
    commit(SET_CHECKLIST_DATA, {
      savedChecklists,
      savedFuel,
      machineImages,
      checklistPhysical,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      emailNotifications,
      videos
    });
  },
  async consultOldChecklistData({ commit }, data) {
    const {
      savedChecklists,
      actualStateImages,
      savedHorometro,
      savedFuel,
      signedChecklistDeliverer,
      emailNotifications,
      signedChecklistReceiver
    } = data;
    const checklistPhysical = {
      src: null,
      titleSection: "Frente"
    };
    const machineImages = [
      { titleSection: "Frente", src: null, id: 1, oldId: "frente" },
      { titleSection: "Posterior", src: null, id: 2, oldId: "posterior" },
      { titleSection: "Lateral 1", src: null, id: 3, oldId: "lateral1" },
      { titleSection: "Lateral 2", src: null, id: 4, oldId: "lateral2" },
      { titleSection: "Llanta FD", src: null, id: 5, oldId: "llantaFd" },
      { titleSection: "Llanta FI", src: null, id: 6, oldId: "llantaFi" },
      { titleSection: "Lanta PD", src: null, id: 7, oldId: "llantaPd" },
      { titleSection: "Llanta PI", src: null, id: 8, oldId: "llantaPi" }
    ];
    for (let index = 0; index < savedChecklists.length; index++) {
      const checklist = savedChecklists[index];
      if (checklist.incidence) {
        let currentIndexImage = 0;
        const imagesByChecklist = { ...checklist.images };
        savedChecklists[index].images = [];
        savedChecklists[index].checklistName = camelize(
          savedChecklists[index].title
        );
        for (const key in imagesByChecklist) {
          if (Object.hasOwnProperty.call(imagesByChecklist, key)) {
            const image = imagesByChecklist[key].thumb;
            savedChecklists[index].images.push({
              src: image,
              id: currentIndexImage,
              titleSection: `Tomar foto ${currentIndexImage + 1}`
            });
            currentIndexImage++;
          }
        }
      }
    }
    for (const key in actualStateImages) {
      if (Object.hasOwnProperty.call(actualStateImages, key)) {
        const image = actualStateImages[key].thumb;
        if (!savedHorometro.notApply && key.includes("checkHorometro"))
          savedHorometro.image = image;
        if (key.includes("checkPhysical")) checklistPhysical.src = image;
        if (!key.includes("checkHorometro") && !key.includes("checkPhysical")) {
          for (let iMachine = 0; iMachine < machineImages.length; iMachine++) {
            const imageM = machineImages[iMachine];
            if (key.includes(imageM.oldId)) machineImages[iMachine].src = image;
          }
        }
      }
    }
    if (signedChecklistDeliverer.identificationImages) {
      if (signedChecklistDeliverer.identificationImages.back) {
        signedChecklistDeliverer.identificationBack =
          signedChecklistDeliverer.identificationImages.back;
      }
      if (signedChecklistDeliverer.identificationImages.front) {
        signedChecklistDeliverer.identificationFront =
          signedChecklistDeliverer.identificationImages.front;
      }
    }
    if (signedChecklistReceiver.identificationImages) {
      if (signedChecklistReceiver.identificationImages.back) {
        signedChecklistReceiver.identificationBack =
          signedChecklistReceiver.identificationImages.back;
      }
      if (signedChecklistReceiver.identificationImages.front) {
        signedChecklistReceiver.identificationFront =
          signedChecklistReceiver.identificationImages.front;
      }
      if (signedChecklistReceiver.orderImages.front) {
        signedChecklistReceiver.orderFront =
          signedChecklistReceiver.orderImages.front;
      }
      if (signedChecklistReceiver.orderImages.back) {
        signedChecklistReceiver.orderBack =
          signedChecklistReceiver.orderImages.back;
      }
    }
    commit(SET_CHECKLIST_DATA, {
      savedChecklists,
      savedFuel,
      machineImages,
      checklistPhysical,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      emailNotifications
    });
  },
  async getChecklistDataTransfer({ commit }, data) {
    const checklistRef = await firestore("transfers")
      .doc(data.id)
      .collection("checklist")
      .where("event", "==", data.checklistType)
      .where("completed", "==", true)
      .limit(1)
      .get();
    checklistRef.forEach(checklist => {
      if (data.actualState) {
        commit(ACTUAL_STATE_IMAGES_GET, checklist.data());
      } else if (data.checklistArray) {
        commit(FUEL_ARRAY_GET, checklist.data().savedFuel);
        commit(HOROMETRO_SET_DATA, checklist.data().savedHorometro);
        commit(MAIN_CHECKLIST_ARRAY_GET, checklist.data());
      } else if (data.checklistItem) {
        commit(CHECKLIST_ITEM_DATA_GET, {
          data: checklist.data(),
          title: data.title
        });
      }
    });
  },
  async saveSignChecklistTransportist({ dispatch }, data) {
    loaderStart();
    try {
      const url = getImageURL(
        data.checklistPath,
        data.sign,
        "signedChecklistDeliverer"
      );
      dispatch("saveImageInFirebaseDoc", {
        image: data.sign,
        url
      });
      const signedChecklistDeliverer = {
        directDelivery: data.nobodyDelivered ? data.nobodyDelivered : false,
        name: data.nameDelivered,
        signImage: url,
        signed: true
      };
      const checklistRef = firestoreDb.doc(data.checklistPath);
      checklistRef.set({ signedChecklistDeliverer }, { merge: true });
    } catch (error) {
      errorMessage("Error al guardar firma");
    } finally {
      loaderDone();
    }
  },
  async saveSignChecklistReceptor({ dispatch }, data) {
    loaderStart();
    try {
      const checklistPath = data.checklistPath;
      let url = "";
      const checklistRef = firestoreDb.doc(checklistPath);
      let signObject = {
        signedChecklistDeliverer: {
          name: data.nameReceives,
          signImage: "pre-process",
          signed: true,
          identificationFront: "pre-process",
          identificationBack: "pre-process"
        }
      };
      if (data.step == 1) {
        url = getImageURL(
          checklistPath,
          data.images[2],
          "signedChecklistDeliverer-2"
        );
        dispatch("saveImageInFirebaseDoc", {
          image: data.images[2],
          url
        });
        signObject.signedChecklistDeliverer.signImage = url;
        url = getImageURL(
          checklistPath,
          data.images[0],
          "signedChecklistDeliverer-0"
        );
        dispatch("saveImageInFirebaseDoc", {
          image: data.images[0],
          url
        });
        signObject.signedChecklistDeliverer.identificationFront = url;
        url = getImageURL(
          checklistPath,
          data.images[1],
          "signedChecklistDeliverer-1"
        );
        dispatch("saveImageInFirebaseDoc", {
          image: data.images[1],
          url
        });
        signObject.signedChecklistDeliverer.identificationBack = url;
      }
      if (data.step == 2) {
        if (data.checkOrderImages) {
          signObject = {
            signedChecklistReceiver: {
              name: data.nameReceives,
              signImage: "pre-process",
              signed: true,
              identificationFront: "pre-process",
              identificationBack: "pre-process",
              orderFront: "pre-process",
              orderBack: "pre-process"
            }
          };
          url = getImageURL(
            checklistPath,
            data.images[4],
            "signedChecklistReceiver-4"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[4],
            url
          });
          signObject.signedChecklistReceiver.signImage = url;
          url = getImageURL(
            checklistPath,
            data.images[0],
            "signedChecklistReceiver-0"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[0],
            url
          });
          signObject.signedChecklistReceiver.identificationFront = url;
          url = getImageURL(
            checklistPath,
            data.images[1],
            "signedChecklistReceiver-1"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[1],
            url
          });
          signObject.signedChecklistReceiver.identificationBack = url;
          url = getImageURL(
            checklistPath,
            data.images[2],
            "signedChecklistReceiver-2"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[2],
            url
          });
          signObject.signedChecklistReceiver.orderFront = url;
          url = getImageURL(
            checklistPath,
            data.images[3],
            "signedChecklistReceiver-3"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[3],
            url
          });
          signObject.signedChecklistReceiver.orderBack = url;
        } else {
          signObject = {
            signedChecklistReceiver: {
              name: data.nameReceives,
              signImage: "pre-process",
              signed: true,
              identificationFront: "pre-process",
              identificationBack: "pre-process"
            }
          };
          url = getImageURL(
            checklistPath,
            data.images[2],
            "signedChecklistReceiver-2"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[2],
            url
          });
          signObject.signedChecklistReceiver.signImage = url;
          url = getImageURL(
            checklistPath,
            data.images[0],
            "signedChecklistReceiver-0"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[0],
            url
          });
          signObject.signedChecklistReceiver.identificationFront = url;
          url = getImageURL(
            checklistPath,
            data.images[1],
            "signedChecklistReceiver-1"
          );
          dispatch("saveImageInFirebaseDoc", {
            image: data.images[1],
            url
          });
          signObject.signedChecklistReceiver.identificationBack = url;
        }
      }
      checklistRef.set(signObject, { merge: true });
    } catch {
      errorMessage("Error al guardar firma");
    } finally {
      loaderDone();
    }
  },
  async sendMail({ commit }, data) {
    await firestoreDb.collection("mail").add({
      to: "inspeccion@prosic.com",
      cc: "egomez@prosic.com",
      message: {
        subject: `App de Inspección: Incidencia en el pedido ${data.number}`,
        html: answersEmail({ number: data.number, path: data.path })
      }
    });
    commit(CHECKLIST_DATA_RESET);
  },
  // :: saveStatusDetail
  // :: save product status
  async saveStatusDetail({ commit }, data) {
    try {
      commit(SAVE_STATUS_DETAIL, {
        machineSerie: data.machineSerie,
        event: data.event,
        inputOuput: data.inputOuput
      });
    } catch (error) {
      errorMessage(
        "No se pudo guardar el estatus del producto, ocurrio un error inesperado."
      );
    }
  },
  async getOrderData({ commit }, data) {
    const { orderId, productID } = data;
    try {
      const orderRef = await firestore("damages")
        .doc(orderId)
        .get();
      const machineSeries = await firestore("damages")
        .doc(orderId)
        .collection("order")
        .doc(productID)
        .get();
      commit(SET_ORDER_DATA, orderRef.data());
      commit(SAVE_STATUS_DETAIL, {
        machineSerie: machineSeries.data().machineSerie,
        event: null,
        inputOuput: null
      });
      return orderRef.data();
    } catch (error) {
      errorMessage(
        "No se pudo guardar el estatus del producto, ocurrio un error inesperado."
      );
    }
  },
  /**
   * Creates and saves the checklist URL into odoo rest api.
   * @param {*} orderData Order data contains an object with the next attributes;
   * orderID: contains the id of an order in database
   * productID: contains the id of the machine that is in the order
   * event: contains the kind of event that is going to be saved in database (delivery, maintenance, recollection, relocation)
   * type: contains the type of checklist that is going to be save in database (input, output)
   */
  async postChecklistUrlIntoOdoo({ commit }, orderData) {
    try {
      const orderInfo = await firestore("damages")
        .doc(orderData.orderID)
        .get();
      const productInfo = await firestore("damages")
        .doc(orderData.orderID)
        .collection("order")
        .doc(orderData.productID)
        .get();
      if (
        productInfo.data().status !== "rented-serviceOutput" &&
        productInfo.data().status !== "rented-serviceInput"
      ) {
        const sale_order_id = orderInfo.data().saleOrderID;
        const product_serie_id = productInfo.data().machineSerie;
        const saveChecklistUrlIntoOdoo = functions.httpsCallable(
          "saveChecklistUrlIntoOdoo"
        );

        const checklistUrl = `https://${
          process.env.VUE_APP_FIREBASE_PROJECT_ID
        }.web.app/incidencias/pedidos/${orderData.orderID}/checklist/${
          orderData.productID
        }/${orderData.event}/detalle/${orderData.type}`;

        const result = await saveChecklistUrlIntoOdoo({
          sale_order_id,
          product_serie_id,
          checklistUrl
        });
        commit(ODOO_CHECKLIST_URL_SAVE, result.data.result);
      }
    } catch (error) {
      errorMessage("No fue posible guardar el checklist en odoo");
    }
  },
  resetChecklist({ commit }) {
    commit(HOROMETRO_RESET_DATA);
    commit(CHECKLIST_DATA_RESET);
  },
  analyticsReport(_, data) {
    const { userUid } = data;
    try {
      const timestamp = moment().unix();
      const ref = `analytics/users/${userUid}/${timestamp}`;
      const refGeneral = `analytics/global/${timestamp}`;
      database(ref).set({ ...data, completed: moment().format() });
      database(refGeneral).set({ ...data, completed: moment().format() });
    } catch (error) {
      errorMessage("No fue posible Actualizar los analiticos");
    }
  },
  analyticsReportIncidence(_, data) {
    for (const incidence of data) {
      const timestamp = moment().unix();
      try {
        if (incidence) {
          const ref = `analytics/checklistFields/${timestamp}`;
          database(ref).set({
            ...incidence,
            dateRegister: moment().format()
          });
          // Transaction for counter
          database(
            `analytics/checklistGlobalFields/${incidence.title}`
          ).transaction(actualTotalReports => {
            actualTotalReports = actualTotalReports || 0;
            actualTotalReports = actualTotalReports + 1;
            return actualTotalReports;
          });
        }
      } catch (error) {
        errorMessage(
          "No fue posible actualizar la incidencia de los analiticos"
        );
      }
    }
  },
  async getAnalytics(_, query) {
    const { userUid, startAt, endAt, components, globalCheck } = query;
    try {
      const ref = `analytics/users`;
      let reportData = null;
      if (components) {
        if (globalCheck) {
          reportData = await database("analytics/checklistGlobalFields").once(
            "value"
          );
        } else {
          reportData = await database("analytics")
            .child("checklistFields")
            .orderByChild("dateRegister")
            .startAt(startAt)
            .endAt(endAt)
            .once("value");
        }
      } else {
        if (userUid) {
          reportData = await database(ref)
            .child(userUid)
            .orderByChild("completed")
            .startAt(startAt)
            .endAt(endAt)
            .once("value");
        } else {
          reportData = await database("analytics")
            .child("global")
            .orderByChild("completed")
            .startAt(startAt)
            .endAt(endAt)
            .once("value");
        }
      }
      const temData = [];
      if (components && globalCheck) {
        return reportData.val();
      }
      reportData.forEach(childSnap => {
        temData.push(childSnap.val());
      });
      return temData;
      // const checklistData = await database("analytics/checklist").once("value");
      // console.log(checklistData.val());
    } catch (error) {
      console.log(error);
    }
  },
  async getChecklistCompleted(_, query) {
    const { startAt, endAt, status, user } = query;
    try {
      let result = null;
      let listData = null;
      if (user) {
        listData = await database("analytics/users")
          .child(user)
          .orderByChild("completed")
          .startAt(startAt)
          .endAt(endAt)
          .once("value");
      } else {
        listData = await database("analytics")
          .child("global")
          .orderByChild("completed")
          .startAt(startAt)
          .endAt(endAt)
          .once("value");
      }
      switch (status) {
        case "Entregas (E)":
          result = filterStatusChecklist(listData.val(), "delivery", "input");
          return result;
        case "Entregas (S)":
          result = filterStatusChecklist(listData.val(), "delivery", "output");
          return result;
        case "Mantenimiento (E)":
          result = filterStatusChecklist(
            listData.val(),
            "maintenance",
            "input"
          );
          return result;
        case "Mantenimiento (S)":
          result = filterStatusChecklist(
            listData.val(),
            "maintenance",
            "output"
          );
          return result;
        case "Recolección (E)":
          result = filterStatusChecklist(
            listData.val(),
            "recollection",
            "input"
          );
          return result;
        case "Recolección (S)":
          result = filterStatusChecklist(
            listData.val(),
            "recollection",
            "output"
          );
          return result;
        case "Reubicación (E)":
          result = filterStatusChecklist(listData.val(), "relocation", "input");
          return result;
        case "Reubicación (S)":
          result = filterStatusChecklist(
            listData.val(),
            "relocation",
            "output"
          );
          return result;
        case "Rentado Servicio (E)":
          result = filterStatusChecklist(
            listData.val(),
            "rented-service",
            "input"
          );
          return result;
        case "Rentado Servicio (S)":
          result = filterStatusChecklist(
            listData.val(),
            "rented-service",
            "output"
          );
          return result;
        case "Traspasos (E)":
          result = filterStatusChecklist(listData.val(), "traspasos", "input");
          return result;
        case "Traspasos (S)":
          result = filterStatusChecklist(listData.val(), "traspasos", "output");
          return result;
        case "Damages":
          result = filterIncidences(listData.val());
          return result;

        default:
          return listData.val() ? Object.values(listData.val()) : [];
      }
    } catch (error) {
      errorMessage("Error al obtener los checklist");
    }
  },
  async getSingleOrder(_, checkData) {
    try {
      const tempData = [];
      for (const key in checkData) {
        if (Object.hasOwnProperty.call(checkData, key)) {
          const listOrderData = checkData[key];
          if (listOrderData.eventType === "traspasos") {
            const transferData = (await firestore("transfers")
              .doc(listOrderData.orderID)
              .get()).data();
            tempData.push({
              ...transferData,
              saleOrderID: transferData.id,
              completed: listOrderData.completed,
              eventType: listOrderData.eventType,
              statusType: listOrderData.statusType
            });
          }
          if (listOrderData.orderID && listOrderData.productID) {
            const productDataSnap = await firestore("damages")
              .doc(listOrderData.orderID)
              .get();
            const productData = productDataSnap.data();
            const orderDataSnap = await firestore("damages")
              .doc(listOrderData.orderID)
              .collection("order")
              .doc(listOrderData.productID)
              .get();
            const orderData = orderDataSnap.data();
            tempData.push({
              ...orderData,
              productID: productData.id,
              saleOrderID: productData.saleOrderID,
              completed: listOrderData.completed,
              eventType: listOrderData.eventType,
              statusType: listOrderData.statusType,
              oID: listOrderData.orderID,
              pID: listOrderData.productID
            });
          }
        }
      }
      return tempData;
    } catch (error) {
      errorMessage("Error al obtener el checklist");
    }
  },
  async getUsageAnalytics(_, query) {
    const { startAt, endAt, globalCheck } = query;
    try {
      let reportData = null;
      let reportUpdatesData = null;
      if (globalCheck) {
        reportData = await database("usersTimeLogs/global").once("value");
        reportUpdatesData = await database("updatesLogs/global").once("value");
      } else {
        reportData = await database("usersTimeLogs")
          .child("global")
          .orderByChild("created")
          .startAt(startAt)
          .endAt(endAt)
          .once("value");

        reportUpdatesData = await database("updatesLogs")
          .child("global")
          .orderByChild("created")
          .startAt(startAt)
          .endAt(endAt)
          .once("value");
      }
      if (!reportData.exists() && !reportUpdatesData.exists()) return [];
      const data = reportData.exists() ? Object.values(reportData.val()) : [];
      const dataUpdates = reportUpdatesData.exists()
        ? Object.values(reportUpdatesData.val())
        : [];
      const resultTransform = {};
      const allUserData = [];
      for (const user of data) {
        if (!resultTransform[user.uid])
          resultTransform[user.uid] = {
            total: 0,
            spend: 0,
            uid: user.uid,
            updates: 0
          };
        resultTransform[user.uid].total = resultTransform[user.uid].total + 1;

        if (user.disconnected)
          resultTransform[user.uid].spend =
            resultTransform[user.uid].spend +
            (user.disconnected - user.connected);
      }
      for (const userUpdates of dataUpdates) {
        resultTransform[userUpdates.uid].updates =
          resultTransform[userUpdates.uid].updates + 1;
      }
      for (const userId in resultTransform) {
        if (Object.hasOwnProperty.call(resultTransform, userId)) {
          const content = resultTransform[userId];
          const userData = (await firestore("users")
            .doc(userId)
            .get()).data();
          if (userData)
            allUserData.push({
              name: userData.name,
              ...content
            });
        }
      }
      return allUserData;
    } catch (error) {
      console.log(error);
    }
  },
  async getUsageUserAnalytics({ state }, query) {
    const { startAt, endAt, branch } = query;
    try {
      let dataUsers = await firestore("users").get();
      if (branch != 1)
        dataUsers = await firestore("users")
          .where("branch", "==", branch)
          .get();
      let reportChecklistData = await database("analytics")
        .child("global")
        .orderByChild("completed")
        .startAt(startAt)
        .endAt(endAt)
        .once("value");
      const dataChecklist = reportChecklistData.exists()
        ? Object.values(reportChecklistData.val())
        : [];
      const allUserData = [];
      for (const userSnap of dataUsers.docs) {
        const user = userSnap.data();
        if (user.uid) {
          const userData = {
            name: user.name,
            branch: getBranchName(state.branchs, user.branch),
            access: "",
            entregas: 0,
            recoleccion: 0,
            reubicacion: 0,
            mantenimiento: 0,
            rentado: 0,
            total: 0
          };
          const lastConnected = await database(
            `usersTimeLogs/byUser/${user.uid}`
          )
            .child("last_connected")
            .once("value");
          userData.access = lastConnected.val()
            ? moment(lastConnected.val().created).format(
                "MMMM Do YYYY, h:mm:ss a"
              )
            : "N/A";
          const totalUserChecklists = getTotalChecklistByUser(
            dataChecklist,
            user.uid,
            "userUid"
          );
          if (totalUserChecklists > 0) {
            userData.entregas = getChecklistByUser(
              dataChecklist,
              "delivery",
              "eventType",
              user.uid
            );
            userData.recoleccion = getChecklistByUser(
              dataChecklist,
              "recollection",
              "eventType",
              user.uid
            );
            userData.reubicacion = getChecklistByUser(
              dataChecklist,
              "relocation",
              "eventType",
              user.uid
            );
            userData.mantenimiento = getChecklistByUser(
              dataChecklist,
              "maintenance",
              "eventType",
              user.uid
            );
            userData.rentado = getChecklistByUser(
              dataChecklist,
              "rented-service",
              "eventType",
              user.uid
            );
          }
          userData.total = totalUserChecklists;
          allUserData.push(userData);
        }
      }
      return allUserData;
    } catch (error) {
      console.log(error);
    }
  },
  async getBranch({ commit }) {
    try {
      //const updateBranchs = functions.httpsCallable("updateBranchs");
      //      await updateBranchs();
      const branchData = await database("branchs").once("value");
      commit(SET_BRANCH_DATA, branchData.val());
    } catch (error) {
      console.log(error);
    }
  },
  updateEmailNotification({ commit }, data) {
    commit(SET_EMAILS_NOTIFICATIONS, data);
  }
};

function getTotalChecklistByUser(dataChecklist, value, key) {
  const userChecklist = dataChecklist.filter(el => {
    return el[key] === value;
  });
  return userChecklist.length;
}
function getChecklistByUser(dataChecklist, value, key, uid) {
  const userChecklist = dataChecklist.filter(el => {
    return el[key] === value && el["userUid"] === uid;
  });
  return userChecklist.length;
}
function getBranchName(branchs, toSearch) {
  const branch = branchs.find(el => el.value === toSearch);
  if (branch) return branch.title;
  return "Sin sucursal";
}
function filterStatusChecklist(data, filterBy, status) {
  if (data) {
    const tempData = Object.values(data).filter(cData => {
      if (cData.eventType && cData.statusType)
        return cData.eventType === filterBy && cData.statusType === status;
    });
    return tempData;
  }
  return [];
}

function filterIncidences(data) {
  if (data) {
    const filter = Object.values(data).filter(currentData => {
      return currentData.incidence === true;
    });
    return filter;
  } else {
    return [];
  }
}
function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
}
